module.exports = __webpack_public_path__ + "img/Perks-Gift-45.7433f7e6.png";